import { BaseModel } from '../../core/abstractions/base.model';
import { OptionalProperty } from '../types/optional-property.type';
import { ResourceConfigActions } from './resource-config-actions';

/**
 * Resource configuration.
 */
export class ResourceConfig extends BaseModel {
    /**
     * Base controller.
     * In standard use cases, it will be the controller's name.
     *  - i.e: For the controller UsersController one route /api/users/... The value "users" should be provided.
     * A full URL (absolute) is also accepted for special cases.
     * In this scenario, the base URL of the app will be ignored and this URL will be used instead.
     * Obs: It should start with "[protocol]://" where protocol can be "http", "https", "ftp", etc.
     *  - i.e: "https://external-server.com/api-address/zip-code"
     */
    baseController: string;

    /**
     * Actions.
     * Allows to change the name of the actions, if they're not standard.
     */
    actions = new ResourceConfigActions();

    constructor(init: OptionalProperty<ResourceConfig, 'actions'>) {
        super();
        Object.assign(this, init);
    }
}
